'use client'

import { Box, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { ContentContainer } from 'ui'
import { FC } from 'react'
import { SectionLabel, SectionTitle, BlockCard } from '../_components/granditude'
import { FiHome, FiFileText, FiTruck, FiDollarSign, FiUploadCloud, FiLayers } from 'react-icons/fi'
import { TbRobot } from 'react-icons/tb'

const blocks = [
  {
    icon: FiHome,
    title: 'Storefronts',
    description: 'Online stores, B2B portals, multi-market'
  },
  {
    icon: FiFileText,
    title: 'Product Data',
    description: 'PIM, AI content, translations'
  },
  {
    icon: FiTruck,
    title: 'Orders',
    description: 'Order management, fulfillment, inventory'
  },
  {
    icon: FiDollarSign,
    title: 'Pricing',
    description: 'Price optimization, discount campaigns'
  },
  {
    icon: FiUploadCloud,
    title: 'Integrations',
    description: 'Connect anything to anything'
  },
  {
    icon: FiLayers,
    title: 'Custom',
    description: 'When nothing else fits, we build it'
  }
]

export const BuildingBlocksSection: FC = () => {
  return (
    <Box as="section" w="100%" py={{ base: 16, md: 32 }}>
      <ContentContainer>
        <VStack w="100%" textAlign="center" spacing={0}>
          <SectionLabel>What We Build</SectionLabel>
          <SectionTitle>Our building blocks</SectionTitle>
          <Text fontSize="1.1rem" color="text.secondary" maxW="600px" mx="auto" mb={10}>
            We don&apos;t sell fixed packages. We assemble solutions from proven tools we&apos;ve
            built and refined over years.
          </Text>

          <Box
            w="100%"
            position="relative"
            bgGradient="linear(135deg, rgba(27, 133, 145, 0.08) 0%, rgba(27, 133, 145, 0.03) 100%)"
            border="2px solid"
            borderColor="teal.500"
            borderRadius="16px"
            p={{ base: 6, md: 10 }}
            pt={{ base: 10, md: 14 }}
          >
            {/* AI Brain Label */}
            <Box
              position="absolute"
              top="-14px"
              left="50%"
              transform="translateX(-50%)"
              bg="teal.500"
              color="white"
              px={6}
              py={2}
              borderRadius="20px"
              fontSize={{ base: '0.85rem', md: '0.95rem' }}
              fontWeight={600}
              display="flex"
              alignItems="center"
              gap={2}
              whiteSpace="nowrap"
            >
              <TbRobot size={22} />
              AI Brain
            </Box>

            <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={6}>
              {blocks.map((block, index) => (
                <BlockCard key={index} {...block} />
              ))}
            </SimpleGrid>
          </Box>
        </VStack>
      </ContentContainer>
    </Box>
  )
}
